import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Inject, OnInit } from '@angular/core';

// Image Preview Dialog Component
@Component({
  selector: 'app-image-preview-dialog',
  template: `
    <div class="p-4 max-w-[90vw] max-h-[90vh] overflow-hidden" data-cy="image-preview-dialog">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">{{ data.title }}</h2>
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="flex justify-center items-center">
        <img
          [src]="data.src"
          [alt]="data.title"
          class="max-w-full max-h-[80vh] object-contain rounded shadow-lg"
          (error)="onImageError()" />
      </div>

      <div class="flex justify-center mt-4">
        <button class="dd-action-button" mat-flat-button (click)="close()">Sluiten</button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImagePreviewDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ImagePreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { src: string; title: string }
  ) {}

  ngOnInit() {
    console.log(this.data);
  }

  close(): void {
    this.dialogRef.close();
  }

  onImageError(): void {
    console.error('Failed to load image preview');
  }
}
